import React, {Component} from 'react';
import {ShipContextProvider, ShipContext} from "./context/ShipContext";
import ApplicationArea from './ApplicationArea'


class TwoDShip extends Component {
    constructor(props) {
        super(props);
        this.props.setShipType(this.props.ship);
    }

    render() {
        const shipModelAreas = this.props.applicationAreas.map((area) =>
            <ApplicationArea
                threeDShip={false}
                key={area.name}
                area={area}
                engineRoomImgUrl={this.props.shipAssets.engineRoomUrl}
            />
        );

        let styles = {};
        styles.opacity = this.props.activeShip === this.props.ship ? '1' : '0';
        styles.pointerEvents = this.props.activeShip === this.props.ship ? 'auto' : 'none';

        return (
            <div className="ships-viewer__container" style={styles}>
                <img className="ships-viewer__ship-image"
                     src={this.props.shipAssets.imageUrl}
                     alt=""
                />
                {shipModelAreas}
            </div>
        )
    }
}

function TwoDShipWithContext(props) {
    return (
        <ShipContextProvider>
            <ShipContext.Consumer>
                {(shipContext) => (
                    <TwoDShip
                        setShipType={shipContext.setShipType}
                        {...props}
                    />
                )}
            </ShipContext.Consumer>
        </ShipContextProvider>
    )
}

export default TwoDShipWithContext;